import script from "./UserDataUpdateComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./UserDataUpdateComponent.vue?vue&type=script&setup=true&lang=js"

import "./UserDataUpdateComponent.vue?vue&type=style&index=0&id=6c19274c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6c19274c"]])

export default __exports__